/** @format */

import React, { useState } from "react";

const Modal = ({ isOpen, onRequestClose, children }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-50 bg-[#F5F5FFCC]">
      <div className="bg-white w-96 rounded-lg shadow-lg">
        {children}
        <div className="flex justify-end mt-2 bg-[#F5F5F5] p-2">
          <button
            className="text-xs px-3 py-1 bg-[#4C4DDC] text-white rounded hover:bg-blue-600"
            onClick={onRequestClose}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

const Card = ({ title, content }) => (
  <div className="bg-[#F5F5FF] p-4 rounded-lg border border-[#DFE0F3]">
    <h4 className="text-sm text-[#616161] font-thin mb-3">{title}</h4>
    <p className="text-lg">{content}</p>
  </div>
);

const Recommendation = ({
  decision,
  handleDecisionChange,
  handleConfirmSelection,
  isDropdownOpen,
  toggleDropdown,
}) => (
  <div className="col-span-1 px-6 rounded">
    <h3 className="text-lg font-medium mb-4">Recommendation</h3>
    <div className="flex flex-col gap-4">
      <Card title="Highest loanable amount" content="150,000 NGN" />
      <Card title="Repayment period" content="6 months" />
      <Card title="Default probability" content="25%" />
    </div>
    <div className="mt-4">
      <select
        className="w-full bg-white border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500"
        value={decision}
        onChange={handleDecisionChange}
        onClick={toggleDropdown}
      >
        <option value="">Select decision</option>
        <option value="approve">Approve candidate</option>
        <option value="reject">Reject candidate</option>
      </select>
      {isDropdownOpen && (
        <button
          className="font-thin text-sm text-left h-full w-full mt-3 bg-[#4C4DDC] hover:bg-blue-600 text-white py-1 px-3 rounded"
          onClick={handleConfirmSelection}
        >
          Confirm Selection
        </button>
      )}
    </div>
  </div>
);

const PredictionModelAnalysis = () => {
  const [predictionModel, setPredictionModel] = useState("Alpha Model");
  const [decision, setDecision] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleModelChange = (event) => {
    setPredictionModel(event.target.value);
  };

  const handleDecisionChange = (event) => {
    setDecision(event.target.value);
  };

  const handleConfirmSelection = () => {
    setIsModalOpen(true);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
      <div className="col-span-1 px-2 rounded-lg">
        <h3 className="font-medium mb-4 text-lg">Loan Selection</h3>
        <div className="items-center mb-4 text-xs">
          <select
            className="w-full bg-white border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 mb-3"
            value={predictionModel}
            onChange={handleModelChange}
          >
            <option value="Alpha Model">
              20/03/2021 Application for 130,000 NGN
            </option>
            <option value="Beta Model">Beta Model</option>
            <option value="Gamma Model">Gamma Model</option>
          </select>
          <button className="bg-[#F5F5FF] text-[#4C4DDC] p-2 rounded shadow-md">
            Change applied prediction model
          </button>
        </div>
      </div>

      <div className="col-span-1  px-2 rounded-lg">
        <h3 className="text-lg font-medium mb-4">Alpha Model Applied</h3>
        <table className="w-full border rounded-xl">
          <thead>
            <tr className="bg-gray-100">
              <th className="font-[500] text-left py-2 px-4 border-b text-sm">
                Variable
              </th>
              <th className="text-left py-2 px-4 border-b text-sm font-[500]">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="text-[#404040]">
            <tr className="">
              <td className="py-2 px-4 border-b text-sm">Average Debit</td>
              <td className="py-2 px-4 border-b text-sm text-[#CB3A31]">
                Fail
              </td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b text-sm">Average Debit</td>
              <td className="text-[#43936C] py-2 px-4 border-b text-sm">
                Pass
              </td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b text-sm">Average Debit</td>
              <td className="py-2 text-[#43936C] px-4 border-b  text-sm">
                Pass
              </td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b text-sm">Average Debit</td>
              <td className="text-[#CB3A31] py-2 px-4 border-b text-sm">
                Fail
              </td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b text-sm">Average Debit</td>
              <td className="text-[#CB3A31] py-2 px-4 border-b text-sm">
                Fail
              </td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b text-sm">Average Debit</td>
              <td className=" text-[#43936C] py-2 px-4 border-b text-sm">
                Pass
              </td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b text-sm">Average Debit</td>
              <td className="text-[#43936C] py-2 px-4 border-b text-sm">
                Pass
              </td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b text-sm">Average Debit</td>
              <td className="py-2 px-4 border-b text-sm text-[#CB3A31]">
                Fail
              </td>
            </tr>
            <tr>
              <td className="py-2 px-4 border-b text-sm">Average Debit</td>
              <td className="py-2 px-4 border-b text-sm text-[#CB3A31]">
                Fail
              </td>
            </tr>

            <tr className="bg-gray-100">
              <td className="py-2 px-4 border-b text-sm">Result</td>
              <td className="py-2 px-4 border-b text-sm text-[#CB3A31] ">
                Failed
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Recommendation
        decision={decision}
        handleDecisionChange={handleDecisionChange}
        handleConfirmSelection={handleConfirmSelection}
        isDropdownOpen={isDropdownOpen}
        toggleDropdown={toggleDropdown}
      />

      <Modal isOpen={isModalOpen} onRequestClose={closeModal}>
        <div className="p-3">
          <h2 className="font-medium mb-2">Candidate Approved!</h2>
          <p className="text-sm font-thin text-[#616161]">
            An acceptance email will be sent to the candidate in
            <span className="text-[#CD7B2E]"> 15 minutes.</span>
            This gives you the opportunity to modify your decision in case of a
            mistake.
          </p>
        </div>
        <div className="flex justify-end"></div>
      </Modal>
    </div>
  );
};

export default PredictionModelAnalysis;
